export default "<div [innerHtml]= \"htmlContent\"></div>";